/* パスワードリセットモーダル(詳細画面にて使用) */
import React, { memo } from 'react';
import { Col, Modal, Button, FormControl } from 'react-bootstrap';
var PasswordReset = function (_a) {
    var show = _a.show, password = _a.password, password_confirmation = _a.password_confirmation, handleChangePassword = _a.handleChangePassword, handleChangePasswordConfirmation = _a.handleChangePasswordConfirmation, handleClick = _a.handleClick, t = _a.t;
    return (React.createElement(Modal, { id: "read-qrcode", size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null,
            React.createElement("p", null, "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8")),
        React.createElement(Modal.Body, { className: "dialog-body" },
            React.createElement("p", null, "\u65B0\u898F\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"),
            React.createElement("br", null),
            React.createElement("p", null, "\u30D1\u30B9\u30EF\u30FC\u30C9"),
            React.createElement(Col, { md: 12 },
                React.createElement(FormControl, { type: "password", value: password, onChange: handleChangePassword })),
            React.createElement("p", null, "\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D"),
            React.createElement(Col, { md: 12 },
                React.createElement(FormControl, { type: "password", value: password_confirmation, onChange: handleChangePasswordConfirmation }))),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "main-color", onClick: handleClick }, t('OK')))));
};
export default memo(PasswordReset);
